import {
  YPartyKitProvider
} from "./chunk-JKUTO4QP.mjs";
import "./chunk-T4QGUU5E.mjs";

// src/react.ts
import { useEffect, useState } from "react";
function useYProvider(yProviderOptions) {
  const { host, room, party, doc, options } = yProviderOptions;
  const [provider] = useState(
    () => new YPartyKitProvider(
      host || (typeof window !== "undefined" ? window.location.host : "dummy-domain.com"),
      room,
      doc,
      {
        connect: false,
        party,
        ...options
      }
    )
  );
  useEffect(() => {
    provider.connect();
    return () => provider.disconnect();
  }, [provider]);
  return provider;
}
export {
  useYProvider as default
};
